import { useQuery } from "@tanstack/react-query";
import { BASE_URL } from "lib/utilities/globalConstants";
import { tokenResult } from "lib/utilities/tokenResult";
import { UserAuth } from "provider/AuthProvider";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FormViewsCandidatesTable from "customComponents/AdminComponents/FormViewsCandidates";
import { useBreadcrumbs } from "provider/BreadcrumbProvider";
import Loader from "customComponents/Loader";

const FormViewsCandidates = () => {
  let { formId, licence, viewId } = useParams();
  const { user } = UserAuth();
  const { setBreadcrumbs, breadcrumbs } = useBreadcrumbs();

  const [token, setToken] = useState("");

  const getFormViewDetails = async () => {
    const idTokenResult = await tokenResult(user);
    setToken(idTokenResult.token);
    const res = await fetch(`${BASE_URL}admin/getFormViewDetails/${viewId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idTokenResult.token}`,
      },
    });
    const data = await res.json();
    return data;
  };

  const {
    data: result,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["getFormViewDetails", viewId],
    queryFn: getFormViewDetails,
    enabled: !!user,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (result) {
      const data = result.data;

      setBreadcrumbs([
        {
          id: "job-forms",
          label: "Job Forms",
          link: `/admin/${licence}/dashboard`,
        },
        {
          id: "job-role",
          label:
            breadcrumbs.find((b) => b.id === "job-role")?.label || data.form.jobRole || "Job Role",
          link: `/admin/${licence}/dashboard/form/${formId}`,
        },
        {
          id: "form-views",
          label: "Form Views",
          link: `/admin/${licence}/dashboard/form/${formId}/view`,
        },
        {
          id: "form-views-candidates",
          label:
            breadcrumbs.find((b) => b.id === "form-views-candidates")?.label || data.name || "View",
          link: `/admin/${licence}/dashboard/form/${formId}/view/${viewId}`,
        },
      ]);
    }
  }, [result]);

  if (isLoading) return <Loader />;

  if (error) return <div>Error fetching forms: {error.message}</div>;

  return (
    <div className="flex justify-center flex-col">
      <FormViewsCandidatesTable
        version={licence}
        formId={formId}
        viewId={viewId}
        token={token}
        viewData={result.data}
      />
    </div>
  );
};

export default FormViewsCandidates;
